import { readStorage } from "./readStorage";

const cacheVersion = process.env.REACT_APP_CACHE_VERSION;

export function writeStorage(key, value, fireWindowEvent) {
    const jsonString = JSON.stringify(value);
    localStorage.setItem(key, jsonString);
    localStorage.setItem('cache_version', cacheVersion);

    if (fireWindowEvent) {
        const oldValue = readStorage(key);
        const event = new StorageEvent('storage',
            {
                key,
                oldValue,
                newValue: jsonString,
            });
        window.dispatchEvent(event);
    }
}
